import gql from 'graphql-tag';

export const EditorStopHeartbeatMutation = gql`
	mutation EditorStopHeartbeatMutation(
		$contentId: ID!
		$contentType: String!
		$heartbeatUserType: ExperimentalHeartbeatUserType
	) @experimental {
		experimentalEditorStopHeartbeat(
			contentId: $contentId
			contentType: $contentType
			heartbeatUserType: $heartbeatUserType
		)
	}
`;
